export default {
  forward: 'forward',
  backward: 'backward'
};